import { init } from '@sentry/react';
import * as Sentry from '@sentry/react';
import { Route, matchPath } from 'react-router-dom';

import { history } from '../redux/store';

import { MANUAL_SENTRY_ROUTES } from '#constants/routes';
import { SENTRY_REPLAY_ENVS, VALID_SENTRY_ENVS } from '#constants/environments';

const getSentryRateByEnv = () => (SENTRY_REPLAY_ENVS.includes(process.env.REACT_APP_SENTRY_ENV) ? 0.1 : 0);

export const SentryRoute = Sentry.withSentryRouting(Route);
export const configureSentry = () => {
  if (process.env.REACT_APP_SENTRY_DSN && VALID_SENTRY_ENVS.includes(process.env.REACT_APP_SENTRY_ENV)) {
    init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      release: process.env.REACT_APP_SENTRY_RELEASE,
      environment: process.env.REACT_APP_SENTRY_ENV,
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(
            history,
            MANUAL_SENTRY_ROUTES,
            matchPath
          )
        }),
        new Sentry.Replay()
      ],
      tracesSampleRate: getSentryRateByEnv(),
      replaysSessionSampleRate: getSentryRateByEnv(),
      replaysOnErrorSampleRate: 1.0
    });
  }
};
